// 账号密码登录
import { FC, useEffect } from 'react';
import { Link } from 'react-router-dom';
import styles from './index.module.less';

import { Form, Button, Checkbox } from 'antd';
import { InfoCircleFilled, LockOutlined, UserOutlined } from '@ant-design/icons';
import FormInput from '@/common/components/Form/FormInput';
import FormInputPassword from '@/common/components/Form/FormInputPassword';

import { MOBILE_REG } from '@lhb/regexp';
import cs from 'classnames';
import { ChangeModalStatus } from '../ts-config';
import { postLogin } from '@/common/api/common';
import { dispatchLogin } from '@/common/document-event/dispatch';

// const options = [
//   { value: 1, label: <p>记住我<span className={styles.automaticLogin}>（30天内自动登录）</span></p> },
// ];


const pstRule = { pattern: /^.{8,16}$/, message: '请输入8-16位密码' };
const userNamePrefix = (
  <p className={styles.usernameTips}>
    <InfoCircleFilled />
    员工账号规则为：手机号或用户名@企业简称
  </p>
);

const passWordPrefix = (
  <p className={cs(styles.passwordTips, 'color-primary-operate')}>
    <Link to='/user/forget'>忘记密码</Link>
  </p>
);



const AccountLogin: FC<ChangeModalStatus> = ({ showChangeAccount, setDismissLogin }) => {
  const [form] = Form.useForm();
  const dismissLogin = Form.useWatch('dismissLogin', form);
  // const automaticLogin = useSelector((state: any) => state.common.automaticLogin);

  // 信息填写完成填入cookie跳转到首页
  const onFinish = (values: any) => {
    const params = { ...values };
    // 是否需要选择企业
    let isNeedChooseAccount: boolean = false;
    // 如果是手机号入参为mobile
    if (MOBILE_REG.test(values.username)) {
      params.mobile = values.username;
      delete params.username;
      isNeedChooseAccount = true;
    }
    postLogin({ ...params }).then((data) => {
      const { token, employeeId } = data;
      if (token) {
        if (isNeedChooseAccount) {
          showChangeAccount(true, token);
        } else {
          dispatchLogin({ token, employeeId });
        }
      }
    });
  };

  // const changeChecked = (check) => {
  //   console.log('event', check);
  //   dispatch(changeAutomaticLogin(check));
  // };
  useEffect(() => {
    setDismissLogin(dismissLogin);
  }, [dismissLogin]);


  const rememberMePrefix = (
    <div className={cs(styles.rememberMePrefix)}>
      <Form.Item name='dismissLogin' valuePropName='checked' initialValue={true}>
        <Checkbox >记住我<span className={styles.automaticLogin}>（30天内自动登录）</span></Checkbox>
      </Form.Item>
    </div>
  );
  return (
    <div className={styles.AccountLogin}>
      <Form form={form} validateTrigger={['onChange', 'onBlur']} onFinish={onFinish} size='large'>
        <FormInput
          name='username'
          maxLength={30}
          prefix={<UserOutlined />}
          rules={[{ required: true, message: '请输入用户名' }]}
          formItemConfig={{ help: userNamePrefix, className: styles.usernameInput }}
          config={{ autoComplete: 'on' }}
          placeholder='请输入手机号或用户名@企业简称'
        />
        <FormInputPassword
          name='password'
          rules={[{ required: true, message: '请输入密码' }, pstRule]}
          placeholder='请输入密码'
          config={{ maxLength: 16 }}
          prefix={<LockOutlined />}
        />
        <div className={styles.automaticLoginBox}>
          {rememberMePrefix}
          {passWordPrefix}
        </div>
        <Form.Item>
          <Button type='primary' htmlType='submit' block className={styles.submitBtn}>
            登录
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default AccountLogin;
